import React, { Suspense, lazy } from "react";
import "../../components/home/home.css";

import HeroSection from "../../components/home/HeroSection";
import BusinessStory from "../../components/home/story/BusinessStory";
import { useSeo, SEO } from "../../config/seo";

// Lazy-load heavier, below-the-fold sections to keep first paint fast.
const ProblemsWeSolve = lazy(() => import("../../components/home/ProblemsWeSolve"));
const SolutionsSection = lazy(() => import("../../components/home/SolutionsSection"));
const ProcessJourney = lazy(() => import("../../components/home/ProcessJourney"));
const ProjectGallery = lazy(() => import("../../components/home/ProjectGallery"));
const WhyChooseUs = lazy(() => import("../../components/home/WhyChooseUs"));
const StatsSection = lazy(() => import("../../components/home/StatsSection"));
const TestimonialsSection = lazy(() => import("../../components/home/TestimonialsSection"));
const ContactSection = lazy(() => import("../../components/home/ContactSection"));
const AnimatedCTA = lazy(() => import("../../components/common/AnimatedCTA"));

const Loading = () => <div className="cv-lazy-fallback" aria-hidden="true" />;

export default function Home() {
  useSeo(SEO.home);
  return (
    <div className="cv-home">
      <HeroSection />

      {/* The continuous world: challenge -> understanding -> engineering ->
          solution -> integration -> the business running better. */}
      <BusinessStory />

      <Suspense fallback={<Loading />}>
        <ProblemsWeSolve />
        <SolutionsSection />
        <ProcessJourney />
        <ProjectGallery />

        <section className="cv-section cv-section--tight">
          <AnimatedCTA
            eyebrow="Start with the problem"
            title="Tell us what isn't working. We'll tell you what we'd build."
            subtitle="A scoped plan within 48 hours — the business case first, the technology second."
            primary={{ label: "Bring us your challenge", to: "/contactus" }}
            secondary={{ label: "Browse solutions", to: "/service" }}
          />
        </section>

        <WhyChooseUs />
        <StatsSection />
        <TestimonialsSection />
        <ContactSection />
      </Suspense>
    </div>
  );
}
